import "./App.css";
import Routes from "./routes";
import { AuthProvider } from "./contexts/AuthContext";
import { MoodleProvider } from "./contexts/MoodleContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { MoodleProviderV2 } from "./contexts/moodle";
import { useEffect } from "react";
import { useConfig } from "./contexts/config";
import { NativeSpinner } from "./components/Loader/spinner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
const GOOGLE_CLIENT_ID =
  "539273510900-9rhtptache71cis00pophig4t2fiv8u0.apps.googleusercontent.com";

// ✅ Configuración de Microsoft MSAL
const msalConfig = {
  auth: {
    clientId: "2297ba57-9418-406b-9e6e-66592b076bbf", // Obtener de Azure Portal
    authority: "https://login.microsoftonline.com/common", // O tu tenant específico
    redirectUri: window.location.origin, // URL de tu app
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const config = useConfig();

  useEffect(() => {
    if (!config.config) {
      config
        .getConfig()
        .then(console.log)
        .catch((err) => console.log(err));
    }
    // eslint-disable-next-line
  }, []);


  if (!config.config) {
    return <NativeSpinner />;
  }
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} >
      <MsalProvider instance={msalInstance}>
        <ThemeProvider>
          <AuthProvider>
            <MoodleProvider>
              <MoodleProviderV2>
                <Routes />
              </MoodleProviderV2>
            </MoodleProvider>
          </AuthProvider>
        </ThemeProvider>
      </MsalProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
